import { render } from "./PageControl.vue?vue&type=template&id=44b9ce46"
import script from "./PageControl.vue?vue&type=script&lang=js"
export * from "./PageControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__